import axios from "axios";
import { getAccessToken, logout } from "../store/AccessTokenStore";

const createHttp = (useAccessToken = false) => {
  const http = axios.create({
    baseURL: "http://localhost:3001/api",
  });

  http.interceptors.request.use((request) => {
    if (useAccessToken && getAccessToken()) {
      request.headers.Authorization = `Bearer ${getAccessToken()}`;
      return request;
    } else {
      return request;
    }
  });

  http.interceptors.response.use(
    (response) => response.data,
    (error) => {
      if (
        error?.response?.status &&
        [401, 403].includes(error.response.status)
      ) {
        if (getAccessToken()) {
          logout();
          if (window.location.pathname !== "/login") {
            window.location.assign("/login");
          }
        }
      }
      return Promise.reject(error);
    }
  );
  return http;
};

export default createHttp;